import Link from "next/link";
import { useState } from "react";
import dynamic from "next/dynamic";
import { compressImage } from "@utils/compressImage";
import styles from "./postPreview.module.scss";
import { formatDateToPtBR } from "@utils/formatDate";

const PostBadge = dynamic(() => import("@components/PostBadge"));

export interface IPostPreviewProps {
	title: string;
	coverImage: string;
	date: string;
	excerpt: string;
	slug: string;
	altText: string;
	srcSet: string;
	featured?: boolean;
	category?: string | string[];
}

const fallbackUrl = "https://amigoedu.com.br/blogdoamigo/wp-content/uploads/2020/11/faculdade-exterior_.jpg";

const PostPreview = ({ title, altText, coverImage, date, excerpt, slug, featured, category, ...rest }: IPostPreviewProps): JSX.Element => {
	const [imgError, setImgError] = useState(false);

	return (
		<article className={styles.postPreview} {...rest}>
			<Link as={`/${slug}`} href="/[slug]">
				<a>
					<header>
						<figure>
							{!imgError ? (
								<picture>
									<source
										srcSet={compressImage({ url: coverImage || fallbackUrl, width: 392, format: "webp" })}
										type="image/webp"
									/>
									<source srcSet={compressImage({ url: coverImage || fallbackUrl, width: 392 })} type="image/jpeg" />
									<img
										src={compressImage({ url: coverImage || fallbackUrl, width: 392 })}
										alt={altText}
										width="100%"
										height="156"
										onError={() => setImgError(true)}
									/>
								</picture>
							) : (
								<picture>
									<img src={coverImage} alt={altText} width="100%" height="156" onError={() => setImgError(true)} />
								</picture>
							)}
						</figure>
						<div className={styles.badge}>{category ? <PostBadge category={category} /> : <PostBadge featured={featured} />}</div>
					</header>

					<div className={styles.body}>
						<h2 className={featured ? styles.featuredTitle : styles.title}>{title}</h2>
						{date && <small className={styles.date}>{formatDateToPtBR(date)}</small>}

						<div className={styles.content} dangerouslySetInnerHTML={{ __html: excerpt.replace(/<a\b[^>]*>(.*?)<\/a>/i, "") }} />
					</div>
				</a>
			</Link>
		</article>
	);
};

export default PostPreview;
